(function($){
    $(document).ready(function(){
        $('.pma-container').insertAfter($('[data-show-pma="1"]').closest('span'));
        $('body').on('click', '[data-show-pma="1"]', function(){
           $('.pma-container').slideToggle(800);
        })
        $('body').on('click', '.pma-container a', function(e){
            e.preventDefault();
        });
        $('body').on('click', '.pma-container .font-increase, .pma-container .font-decrease', function (e) {
            e.preventDefault();
            var option;
            if($(this).attr('class') == 'font-increase'){
                option = 'plus';
            }
            else{
                option = 'minus';
            }
            change_font(option);
        });
        $('body').on('click', '.pma-container .grayscale', function (e) {
            grayscale();
        });
        $('body').on('click', '.pma-container .high-contrast', function (e) {
            e.preventDefault();
            highcontrast();
        });
        $('body').on('click', '.pma-container .negative-contrast', function (e) {
            e.preventDefault();
            negative();
        });
        $('body').on('click', '.pma-container .light-background', function (e) {
            e.preventDefault();
            lightbkgr();
        });
        $('body').on('click', '.pma-container .links-underline', function (e) {
            e.preventDefault();
            underline();
        });
        $('body').on('click', '.pma-container .readable-font', function (e) {
            e.preventDefault();
            readable();
        });
        $('body').on('click', '.pma-container .reset', function (e) {
            e.preventDefault();
            pm_reset();
        });
    })

    function pm_reset(){
        remove_body_class('readable');
        remove_body_class('underline');
        remove_body_class('lightbkgr');
        remove_body_class('negative');
        remove_body_class('highcontrast');
        remove_body_class('grayscale');
        remove_body_class('change-font-200');
        remove_body_class('change-font-190');
        remove_body_class('change-font-180');
        remove_body_class('change-font-170');
        remove_body_class('change-font-160');
        remove_body_class('change-font-150');
        remove_body_class('change-font-140');
        remove_body_class('change-font-130');
        remove_body_class('change-font-120');
        setTimeout(function(){
            set_pm_cookie();
        }, 500)
    }

    function set_active_link(c) {
        $('.pma-container ' + c).addClass('active');
    }
    function set_inactive_link(c) {
        $('.pma-container ' + c).removeClass('active');
    }

    function set_pm_cookie(){
        $.ajax({

            type: 'post',
            url: footer_ajax.ajaxurl,
            data: {
                action: 'set_pm_cookie',
                cookie: $('body').attr('class'),
            },

            success: function( data ) {
                console.log(data);
            }

        });
    }

    function set_body_class(c){
        $('body').addClass('pm-' + c);
        setTimeout(function(){
            set_pm_cookie();
        }, 500)
    }
    function remove_body_class(c){
        var ec = c.split(',');
        $(ec).each(function(index, value){
            $('body').removeClass('pm-' + value);
        });
        setTimeout(function(){
            set_pm_cookie();
        }, 500)
    }

    function readable(){
        if($('body').hasClass('pm-readable')){
            remove_body_class('readable');
            set_inactive_link('readable');
        }
        else{
            set_body_class('readable');
            set_active_link('readable');
        }
    }
    function underline(){
        if($('body').hasClass('pm-underline')){
            remove_body_class('underline');
            set_inactive_link('underline');
        }
        else{
            set_body_class('underline');
            set_active_link('underline');
        }
    }
    function lightbkgr(){
        remove_body_class('grayscale,highcontrast,negative');
        if($('body').hasClass('pm-lightbkgr')){
            remove_body_class('lightbkgr');
        }
        else{
            set_body_class('lightbkgr');
        }
    }
    function negative(){
        remove_body_class('grayscale,highcontrast,lightbkgr');
        if($('body').hasClass('pm-negative')){
            remove_body_class('negative');
        }
        else{
            set_body_class('negative');
        }
    }
    function highcontrast(){
        remove_body_class('grayscale,negative,lightbkgr');
        if($('body').hasClass('pm-highcontrast')){
            remove_body_class('highcontrast');
        }
        else{
            set_body_class('highcontrast');
        }
    }
    function grayscale(){
        remove_body_class('highcontrast,negative,lightbkgr');
        if($('body').hasClass('pm-grayscale')){
            remove_body_class('grayscale');
        }
        else{
            set_body_class('grayscale');
        }
    }

    function change_font(option){
        var bclass = $('body').attr('class').split(' '), has_change_font = false;
        $(bclass).each(function(index, value){
            if(value.indexOf('pm-change-font') > -1){
                has_change_font = value;
            }
        });
        var current_step;
        if(!has_change_font){
            current_step = 110;
        }
        else{
            current_step = has_change_font.replace('pm-change-font-', '');
        }
        if(option == 'plus' && current_step < 200){
            $('body').removeClass('pm-change-font-' + current_step);
            current_step = current_step*1 + 10;
            $('body').addClass('pm-change-font-' + current_step);
        }
        if(option == 'minus' && current_step > 110){
            $('body').removeClass('pm-change-font-' + current_step);
            current_step = current_step*1 - 10;
            $('body').addClass('pm-change-font-' + current_step);
        }
        setTimeout(function(){
            set_pm_cookie();
        }, 500)
    }

})(jQuery)